import MobileDetect from 'mobile-detect';
import { globalStore } from '@/utils/store.js';

export function taggage(track_zone, track_nom, track_cible, options = {}) {
  const trackingData = {};
  if (track_zone && track_zone != '') trackingData.track_zone = track_zone;
  if (track_nom && track_nom != '') trackingData.track_nom = track_nom;
  if (track_cible) trackingData.track_cible = track_cible;

  if (options.tealium_event) {
    trackingData.tealium_event = options.tealium_event;
  }
  if (options.offre_id) {
    trackingData.offre_id = options.offre_id;
    globalStore.tag.offre_id.push(...options.offre_id);
  }
  if (options.offre_marque) {
    trackingData.offre_marque = options.offre_marque;
    globalStore.tag.offre_marque.push(...options.offre_marque);
  }
  if (options.offre_type) {
    trackingData.offre_type = options.offre_type;
    globalStore.tag.offre_type.push(...options.offre_type);

  }
  if (options.offre_modele) {
    trackingData.offre_modele = options.offre_modele;
    globalStore.tag.offre_modele.push(...options.offre_modele);
  }
  if (options.offre_qte) {
    trackingData.offre_qte = options.offre_qte;
    globalStore.tag.offre_qte.push(...options.offre_qte);
  }
  if (options.offre_libelle) {
    trackingData.offre_libelle = options.offre_libelle;
    globalStore.tag.offre_libelle.push(...options.offre_libelle);
  }
  if (options.offre_prix_ttc) {
    trackingData.offre_prix_ttc = options.offre_prix_ttc;
    globalStore.tag.offre_prix_ttc.push(...options.offre_prix_ttc);
  }

  if (typeof window !== "undefined" && window.utag && typeof window.utag.link === "function") {
    console.log('TRACKING PACKOPEN : Taggage envoyé:' + JSON.stringify(trackingData, null, 2));
    window.utag.link(trackingData);
  } else {
    console.log("TRACKING PACKOPEN : utag.link() n'est pas défini :" + JSON.stringify(trackingData, null, 2));
  }
}

export function taggageRecap(track_zone, track_nom, track_cible, options = {}) {
  const trackingData = {};
  if (track_zone && track_zone != '') trackingData.track_zone = track_zone;
  if (track_nom && track_nom != '') trackingData.track_nom = track_nom;
  if (track_cible) trackingData.track_cible = track_cible;

  if (options.tealium_event) {
    trackingData.tealium_event = options.tealium_event;
  }
  if (options.offre_id) {
    trackingData.offre_id = options.offre_id;
  }
  if (options.offre_marque) {
    trackingData.offre_marque = options.offre_marque;
  }
  if (options.offre_type) {
    trackingData.offre_type = options.offre_type;
  }
  if (options.offre_modele) {
    trackingData.offre_modele = options.offre_modele;
  }
  if (options.offre_qte) {
    trackingData.offre_qte = options.offre_qte;
  }
  if (options.offre_libelle) {
    trackingData.offre_libelle = options.offre_libelle;
  }
  if (options.offre_prix_ttc) {
    trackingData.offre_prix_ttc = options.offre_prix_ttc;
  }

  if (typeof window !== "undefined" && window.utag && typeof window.utag.link === "function") {
    console.log('TRACKING RECAP PACKOPEN : Taggage envoyé:' + JSON.stringify(trackingData, null, 2));
    window.utag.link(trackingData);
  } else {
    console.log("TRACKING RECAP PACKOPEN : utag.link() n'est pas défini :" + JSON.stringify(trackingData, null, 2));
  }
}

export function taggageView(canal, couleur, departement, domaine, segment, sous_univers, titre_page, type_page, univers, device_pixel_ratio) {
  // Construction de l'objet de tracking de base
  const trackingData = {
    "canal": canal, // Zone fonctionnelle du site
    "couleur": couleur,   // Nom de l'action ou composant
    "departement": departement, // Cible ou identifiant de l'élément
    "domaine": domaine, // Cible ou identifiant de l'élément
    "segment": segment, // Cible ou identifiant de l'élément
    "sous_univers": sous_univers, // Cible ou identifiant de l'élément
    "titre_page": titre_page, // Cible ou identifiant de l'élément
    "type_page": type_page, // Cible ou identifiant de l'élément
    "univers": univers, // Cible ou identifiant de l'élément
    "device_pixel_ratio": device_pixel_ratio //
  };

  // Initialisation avec le user agent du navigateur
  const md = new MobileDetect(window.navigator.userAgent);

  // Détection
  const isMobile = !!md.mobile();   // true si smartphone
  const isTablet = !!md.tablet();   // true si tablette
  const isDesktop = !isMobile && !isTablet; // true si desktop

  //if (canal == '') {
    if (isMobile || isTablet) {
      trackingData.canal = "mobile web";
    } else {
      trackingData.canal = "web";
    }
  //}

  trackingData.device_pixel_ratio = window.devicePixelRatio;

  console.log('mobile:'+md.mobile()); // ex: "iPhone" ou null
  console.log('tablette:'+md.tablet()); // ex: "iPad" ou null

  if (typeof window !== "undefined" && window.utag && typeof window.utag.view === "function") {
    console.log('TRACKING VIEW APP : Taggage envoyé:'+ JSON.stringify(trackingData, null, 2));
    utag.link(trackingData);
  } else {
    console.log("TRACKING VIEW APP : utag.link() n'est pas défini : "+JSON.stringify(trackingData, null, 2));
  }

}

export function resetTag(etape) {
  if (etape == 1) {
    globalStore.tag.offre_id.length = 0;
    globalStore.tag.offre_marque.length = 0;
    globalStore.tag.offre_type.length = 0;
    globalStore.tag.offre_modele.length = 0;
    globalStore.tag.offre_qte.length = 0;
    globalStore.tag.offre_libelle.length = 0;
    globalStore.tag.offre_prix_ttc.length = 0;
  }
  if (etape == 2) {
    for (let i = globalStore.tag.offre_type - 1; i >= 0; i--) {
      if (globalStore.tag.offre_type[i] !== 'terminal' || globalStore.tag.offre_type[i] !== 'offre_forfait') {
        globalStore.tag.offre_id.splice(i, 1);
        globalStore.tag.offre_marque.splice(i, 1);
        globalStore.tag.offre_type.splice(i, 1);
        globalStore.tag.offre_modele.splice(i, 1);
        globalStore.tag.offre_qte.splice(i, 1);
        globalStore.tag.offre_libelle.splice(i, 1);
        globalStore.tag.offre_prix_ttc.splice(i, 1);
      }
    }
  }
  if (etape == 3) {
    for (let i = globalStore.tag.offre_type - 1; i >= 0; i--) {
      if (globalStore.tag.offre_type[i] !== 'terminal' || globalStore.tag.offre_type[i] !== 'offre_forfait' || globalStore.tag.offre_type[i] !== 'offre_adsl' || globalStore.tag.offre_type[i] !== 'offre_fibre') {
        globalStore.tag.offre_id.splice(i, 1);
        globalStore.tag.offre_marque.splice(i, 1);
        globalStore.tag.offre_type.splice(i, 1);
        globalStore.tag.offre_modele.splice(i, 1);
        globalStore.tag.offre_qte.splice(i, 1);
        globalStore.tag.offre_libelle.splice(i, 1);
        globalStore.tag.offre_prix_ttc.splice(i, 1);
      }
    }
  }
  if (etape == 4) {
    for (let i = globalStore.tag.offre_type - 1; i >= 0; i--) {
      if (globalStore.tag.offre_type[i] !== 'terminal' || globalStore.tag.offre_type[i] !== 'offre_forfait' || globalStore.tag.offre_type[i] !== 'offre_adsl' || globalStore.tag.offre_type[i] !== 'offre_fibre') {
        globalStore.tag.offre_id.splice(i, 1);
        globalStore.tag.offre_marque.splice(i, 1);
        globalStore.tag.offre_type.splice(i, 1);
        globalStore.tag.offre_modele.splice(i, 1);
        globalStore.tag.offre_qte.splice(i, 1);
        globalStore.tag.offre_libelle.splice(i, 1);
        globalStore.tag.offre_prix_ttc.splice(i, 1);
      }
    }
  }
}

